import { LeftOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button, Divider, Input, Spin, Tooltip } from "antd";
import { debounce, uniq } from "lodash";
import { useEffect, useMemo, useRef, useState } from "react";
import { BsReply } from "react-icons/bs";
import { HiRefresh } from "react-icons/hi";
import { IoMenu, IoSearchOutline, IoSearchSharp } from "react-icons/io5";
import { MdDeleteOutline } from "react-icons/md";
import { useLocation } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import apiFactory from "../../../api";
import { GeneralModal } from "../../../components/modal/GeneralModal";
import { LabelModal } from "../../../components/modal/LabelModal";
import { MemberModal } from "../../../components/modal/MemberModal";
import { SideBarMail } from "../../../components/sideBar/SideBarMail";
import { MAIL } from "../../../config/Constant";
import { useMailContext } from "../../../context/MailContext";
import { useMenuContext } from "../../../context/MenuContext";
import { useInfoUser } from "../../../store/UserStore";
import { openNotificationError } from "../../../utils/Utils";
import { MailReply } from "./MailReply";

import { TiArrowForwardOutline } from "react-icons/ti";
import { CustomAvatar } from "../../../components/avatar/CustomAvatar";
import { ForwardAllMailModal } from "../../../components/modal/ForwardAllMailModal";
import MemberReadUnreadModal from "../../../components/modal/MemberReadUnreadModal";
import { DirectoryProvider } from "../../../components/select/directory/DirectoryContext";
import { useUnsavedChangesBlocker } from "../../../hooks/useUnsavedChangesBlocker";
import { updateOrgList } from "../../../utils/OrganizationHelper";
import { useAuthLayoutContext } from "../../../context/AuthLayoutContext";

const HeaderLeft = ({
  listMember,
  totalMember,
  showModalShowMember,
  ccList,
  totalCC,
}) => {
  const { languageMap } = useInfoUser();
  const { selectedConversation, onBackToConversations } = useMenuContext();

  return (
    <div className="left">
      <button onClick={onBackToConversations}>
        <LeftOutlined />
      </button>
      <div className="flex flex-col me-3 w-full">
        <div className="flex gap-[2px] mb-1 font-bold break-all text-[18px]">
          <div className="text-[#2a56b9]">
            {selectedConversation?.isForwardMail &&
              languageMap?.["mail.title.forward"]}
          </div>
          <div className="text-[#2a56b9]">
            {selectedConversation?.forwardConversationId &&
              (languageMap?.["mail.title.forwardAll"] ??
                "[Forward conversation]")}
          </div>
          <span>
            {languageMap?.[selectedConversation?.name] ??
              selectedConversation?.name}
          </span>
        </div>

        <div className="flex flex-col text-[11px]">
          {listMember?.length > 0 && (
            <div className="flex items-center gap-1">
              <div className="text-[12px] font-semibold text-gray-600 uppercase tracking-wide pl-1 min-w-[100px] flex-shrink-0">
                {languageMap?.["chat.role.conversation.noti.recipient"] ??
                  "Recipient"}
              </div>

              <div
                className="flex items-center overflow-hidden rounded-md pr-2 cursor-pointer"
                onClick={showModalShowMember}
              >
                {listMember
                  ?.filter((s) => s.role === "MEMBER")
                  .slice(0, 7)
                  .map((e) => (
                    <div
                      key={e?.name}
                      className="flex items-center gap-1 px-2 py-1 rounded-md duration-150 flex-shrink-0"
                      title={e?.name}
                    >
                      <CustomAvatar
                        person={e}
                        userId={e?.userId}
                        pos={-1}
                        styleCss={{}}
                        size={20}
                        isShowUserStatus={{
                          status: true,
                          isAlwaysTrue: false,
                        }}
                      />
                      <span className="text-gray-800 text-[10px]">
                        {e?.name}
                      </span>
                    </div>
                  ))}

                {listMember?.filter((s) => s.role === "MEMBER")?.length > 5 && (
                  <div
                    className="flex -space-x-2 ml-2 cursor-pointer"
                    onClick={showModalShowMember}
                  >
                    {listMember
                      .filter((s) => s.role === "MEMBER")
                      .slice(5, 10)
                      .map((e, idx) => (
                        <div
                          key={e?.name}
                          className="w-6 h-6 rounded-full border-2 border-white bg-indigo-100 text-indigo-700 flex items-center justify-center text-[10px] font-semibold"
                          title={e?.name}
                          style={{ zIndex: 1 + idx }}
                        >
                          <CustomAvatar
                            person={e}
                            userId={e?.userId}
                            pos={-1}
                            styleCss={{}}
                            size={20}
                            isShowUserStatus={{
                              status: true,
                              isAlwaysTrue: false,
                            }}
                          />
                        </div>
                      ))}
                    {listMember.filter((s) => s.role === "MEMBER")?.length >
                      12 && (
                      <div
                        className="px-1 z-10 h-6 rounded-full border-2 border-white bg-gray-300 text-gray-700 
                      flex items-center justify-center text-[10px] font-semibold"
                      >
                        +{totalMember - 12}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}

          {ccList?.length > 0 && (
            <div className="flex items-center gap-1">
              <div className="text-[12px] font-semibold text-gray-600 uppercase tracking-wide pl-1 min-w-[100px] flex-shrink-0 ">
                {languageMap?.["modal.notification.cc"] ?? "Cc"}
              </div>

              <div
                className="flex items-center overflow-hidden rounded-md pr-2 cursor-pointer"
                onClick={showModalShowMember}
              >
                {ccList
                  ?.filter((s) => s.role === "CC")
                  .slice(0, 7)
                  .map((e) => (
                    <div
                      key={e?.name}
                      className="flex items-center gap-1 px-2 py-1 rounded-md duration-150 flex-shrink-0"
                      title={e?.name}
                    >
                      <CustomAvatar
                        person={e}
                        userId={e?.userId}
                        pos={-1}
                        styleCss={{}}
                        size={20}
                        isShowUserStatus={{
                          status: true,
                          isAlwaysTrue: false,
                        }}
                      />
                      <span className="text-gray-800 text-[10px]">
                        {e?.name}
                      </span>
                    </div>
                  ))}

                {ccList?.filter((s) => s.role === "CC")?.length > 5 && (
                  <div
                    className="flex -space-x-2 ml-2 cursor-pointer"
                    onClick={showModalShowMember}
                  >
                    {ccList
                      .filter((s) => s.role === "CC")
                      .slice(5, 10)
                      .map((e, idx) => (
                        <div
                          key={e?.name}
                          className="w-6 h-6 rounded-full border-2 border-white bg-indigo-100 text-indigo-700 flex items-center justify-center text-[10px] font-semibold"
                          title={e?.name}
                          style={{ zIndex: 1 + idx }}
                        >
                          <CustomAvatar
                            person={e}
                            userId={e?.userId}
                            pos={-1}
                            styleCss={{}}
                            size={20}
                            isShowUserStatus={{
                              status: true,
                              isAlwaysTrue: false,
                            }}
                          />
                        </div>
                      ))}
                    {ccList.filter((s) => s.role === "CC")?.length > 12 && (
                      <div
                        className="px-1 z-10 h-6 rounded-full border-2 border-white bg-gray-300 text-gray-700 
                      flex items-center justify-center text-[10px] font-semibold"
                      >
                        +{totalCC - 12}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const HeaderRight = ({ isReplyAll, notificationRepliesRef }) => {
  const { user, languageMap } = useInfoUser();
  const { selectedConversation, onSearch, refreshMailMessage } =
    useMenuContext();

  const {
    topMessageList,
    setTopMessageList,
    setIsOpenModalDeleteConversation,
    setIsForwardAllMail,
  } = useMailContext();

  const handleReplyAll = () => {
    if (!isReplyAll) {
      setTopMessageList([
        {
          status: null,
          createdAt: null,
          updatedAt: null,
          requestUuid: uuidv4(),
          conversationId: selectedConversation?.conversationId,
          senderId: user?.userId,
          recipientId: "ALL",
          isDraft: true,
          isEditing: true,
          draftMail: {
            status: null,
            requestUuid: uuidv4(),
            conversationId: selectedConversation?.conversationId,
            senderId: user?.userId,
            recipientId: "ALL",
            content: "",
            files: [],
          },
        },
        ...topMessageList,
      ]);
    } else {
      if (topMessageList?.[0]?.isDraft) {
        topMessageList[0].isEditing = true;
        setTopMessageList([...topMessageList]);
      }
    }

    if (notificationRepliesRef?.current) {
      notificationRepliesRef.current.scrollTop = 0;
    }
  };

  return (
    <div className="right">
      <Tooltip
        placement="bottom"
        title={languageMap?.["modal.notification.replyToAll"] ?? "Reply to all"}
        color={"#0091ff"}
      >
        <Button
          className="bg-[#2a56b9] text-[white]"
          onClick={handleReplyAll}
          icon={<BsReply className="text-[18px]" />}
          disabled
        />
      </Tooltip>
      <Tooltip
        placement="top"
        title={
          languageMap?.["modal.notification.forwardAll"] ??
          "Forward all messages"
        }
        color={"#0091ff"}
      >
        <Button
          className="bg-[#2a56b9] text-[white]"
          onClick={() => setIsForwardAllMail(true)}
          icon={<TiArrowForwardOutline className="text-[18px]" />}
          disabled
        />
      </Tooltip>
      <Tooltip
        placement="bottom"
        title={
          languageMap?.["menu.conversation.searchMessage"] ?? "Search messages"
        }
        color={"#0091ff"}
      >
        <Button
          className="bg-[#2a56b9] text-[white]"
          onClick={onSearch}
          icon={<IoSearchSharp className="text-[18px]" />}
        />
      </Tooltip>
      <Tooltip
        placement="bottom"
        title={languageMap?.["menu.conversation.refresh"] ?? "Refresh"}
        color={"#0091ff"}
      >
        <Button
          className="bg-[#2a56b9] text-[white]"
          onClick={refreshMailMessage}
          icon={<HiRefresh className="text-[18px]" />}
        />
      </Tooltip>
      <Tooltip
        placement="bottom"
        title={languageMap?.["menu.mail.btnDeleteMessage"] ?? "Delete Message"}
        color={"#0091ff"}
      >
        <Button
          className="bg-[#2a56b9] text-[white]"
          onClick={() => setIsOpenModalDeleteConversation(true)}
          icon={<MdDeleteOutline className="text-[18px]" />}
          disabled
        />
      </Tooltip>
    </div>
  );
};

const MailDetail = () => {
  const { languageMap } = useInfoUser();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const recipent = queryParams.get("recipent");

  /** Context */
  const { setOrgList: setOriginalOrgList } = useAuthLayoutContext();
  const {
    setSelectedConversation,
    selectedConversation,
    handleUpdateConversationList,
    conversationList,
    setIsMenu,
    setLabelSelectedId,
    setIsModalLabelGroup,
    onCloseChatMessage,
    isMenu,
    messageSearch,
    setMessageSearch,
    isMessageSearch,
    setIsMessageSearch,
    isModalLabelGroup,
    labelSelectedId,
  } = useMenuContext();

  const {
    topMessageList,
    setTotalNotificationItem,
    bottomMessageList,
    setBottomMessageList,
    setTopMessageList,
    setIsReply,
    lastMessageTs,
    setIsMoreMessage,
    totalNotificationItem,
    setTitle,
    cCOrgList,
    setCCOrgList,
    memberOrgList,
    setMemberOrgList,
    onDeleteMessageNotifications,
    onLoadMore,
    isLoading,
    isOpenModalDeleteConversation,
    setIsOpenModalDeleteConversation,
    isForwardAllMail,
    setIsForwardAllMail,
    isReviewHistory,
  } = useMailContext();

  const inputSearchRef = useRef(null);
  const [listMember, setListMember] = useState([]);
  const [totalMember, setTotalMember] = useState(0);
  const [totalCC, setTotalCC] = useState(0);
  const [isReplyAll, setIsReplyAll] = useState(false);

  const [openModalShowMember, setOpenModalShowMember] = useState(false);
  const [ccList, setCcList] = useState([]);
  const notificationRepliesRef = useRef(null);
  const bottomMessagesRef = useRef(null);

  const [isSendingSuccess, setIsSendingSuccess] = useState(false);
  const [isModalMembersReadUnread, setIsModalMembersReadUnread] =
    useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);

  const mailReplyRefs = useRef({});
  const [dirtyMap, setDirtyMap] = useState({});

  const handleDirtyChange = (id, dirty) =>
    setDirtyMap((prev) => ({ ...prev, [id]: dirty }));

  const isDirty = Object.values(dirtyMap).some(Boolean);

  const {
    isOpenModalNotifyChange,
    handleSaveAndLeave,
    handleDiscardAndLeave,
    handleCancelLeave,
  } = useUnsavedChangesBlocker({
    isDirty,
    onSave: async () => {
      for (const reply of Object.values(mailReplyRefs.current)) {
        await reply?.saveDraft?.();
      }
    },
    onDiscard: () => {
      setDirtyMap({});
    },
  });

  const getListMemberInfo = async (conversationId) => {
    if (!conversationId) return;

    await getListRecipient(conversationId, "RECIPIENT");
    await getListRecipient(conversationId, "CC");
  };

  const getListRecipient = async (conversationId, viewType) => {
    const lstUser = await apiFactory.userConversationApi.getListUserConversation({
      conversationId,
      limit: 30,
      page: 1,
      search: { memberName: "", viewType: viewType },
      ts: lastMessageTs,
    });

    if (lstUser?.status !== 200) {
      openNotificationError(lstUser?.message);
      return;
    }

    updateOrgList(setOriginalOrgList, lstUser?.data?.items);

    if (viewType === "CC") {
      setCcList(lstUser?.data?.items);
      setTotalCC(lstUser?.data?.totalItems);
    } else {
      setListMember(lstUser?.data?.items);
      setTotalMember(lstUser?.data?.totalItems);
    }
  };

  const showModalShowMember = async () => {
    setOpenModalShowMember(true);
  };

  const handleCancelModalShowMember = () => {
    setOpenModalShowMember(false);
  };

  const addMemberOrg = () => {
    let userIds = memberOrgList
      ?.filter((org) => org?.type === "PERSON" && org?.checked)
      ?.map((org) => org?.objectId);
    userIds = uniq(userIds);

    let ccIds = cCOrgList
      ?.filter((org) => org?.type === "PERSON" && org?.checked)
      ?.map((org) => org?.objectId);
    ccIds = uniq(ccIds);

    return { userIds, ccIds };
  };

  const showLoadMoreIcon = useMemo(() => {
    if (
      totalNotificationItem - MAIL.BOTTOM_MESSAGE - MAIL.TOP_MESSAGE > 0 &&
      totalNotificationItem -
        topMessageList?.length -
        bottomMessageList?.length >
        0
    ) {
      return (
        <div className="flex flex-col items-center pt-[10px]">
          <button
            className="rounded-[50%] border-[1px] border-[#cccccc] w-[36px] p-[7px]"
            onClick={onLoadMore}
          >
            {totalNotificationItem - MAIL.BOTTOM_MESSAGE - MAIL.TOP_MESSAGE > 99
              ? "99+"
              : totalNotificationItem -
                topMessageList?.length -
                bottomMessageList?.length}
          </button>
        </div>
      );
    }
  }, [
    selectedConversation,
    totalNotificationItem,
    topMessageList?.length,
    bottomMessageList?.length,
  ]);

  const scrollToTop = () => {
    if (notificationRepliesRef.current) {
      notificationRepliesRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const renderMailDivider = (msg) => {
    if (msg?.forwardLast)
      return (
        <Divider style={{ borderColor: "#2a56b9" }}>
          {msg?.forwardLast && (
            <div className="flex gap-[2px]">
              <span className="text-[#2a56b9]">
                {languageMap?.["mail.title.forwardAll"] ??
                  "[Forward conversation]"}
              </span>
              <span>{languageMap?.[msg?.oldTitle] ?? msg?.oldTitle}</span>
            </div>
          )}
        </Divider>
      );
    return <Divider style={{ borderColor: "#e5e7eb" }} />;
  };

  useEffect(() => {
    setTitle(selectedConversation?.type ? selectedConversation?.name : "");
    setListMember([]);
    setIsMoreMessage(false);
    setIsReply(false);
    setCCOrgList([]);
    setMemberOrgList([]);
  }, [selectedConversation?.conversationId]);

  useEffect(() => {
    if (selectedConversation?.conversationId) {
      getListMemberInfo(selectedConversation?.conversationId);
    }
  }, [selectedConversation?.type, selectedConversation?.conversationId]);

  useEffect(() => {
    if (isMessageSearch) {
      inputSearchRef?.current.focus();
    }
  }, [isMessageSearch]);

  useEffect(() => {
    setIsMessageSearch(false);
  }, [selectedConversation?.conversationId]);

  useEffect(() => {
    setIsReplyAll(
      topMessageList?.findIndex(
        (message) => message && message.isDraft === true,
      ) > -1,
    );
  }, [topMessageList]);

  useEffect(() => {
    if (bottomMessagesRef.current && isSendingSuccess) {
      bottomMessagesRef.current.scrollIntoView({ behavior: "instant" });
      setIsSendingSuccess(false);
    }
  }, [isSendingSuccess]);

  useEffect(() => {
    if (recipent && cCOrgList?.length > 0) {
      const updatedList = cCOrgList?.map((item) => ({
        ...item,
        checked: false,
      }));
      setCCOrgList(updatedList);
    }
    setTitle("");
  }, [recipent]);

  return (
    <div className="flex overflow-hidden flex-1">
      <div className="chat-content h-[100vh]">
        <div className="header sticky top-0 z-50 bg-white shadow-md">
          <HeaderLeft
            listMember={listMember}
            totalMember={totalMember}
            showModalShowMember={showModalShowMember}
            ccList={ccList}
            totalCC={totalCC}
          />
          <button
            className="icon menu-icon"
            onClick={() => {
              setIsMenu(true);
            }}
          >
            <IoMenu size={25} />
          </button>
          <HeaderRight
            isReplyAll={isReplyAll}
            notificationRepliesRef={notificationRepliesRef}
          />
        </div>
        <div className="search-message">
          {isMessageSearch && (
            <div className="flex justify-center items-center p-3">
              <Input
                ref={inputSearchRef}
                placeholder={
                  languageMap?.["messageList.search.placeholder"] ??
                  "Search Message"
                }
                onChange={debounce((e) => {
                  setMessageSearch({
                    ...messageSearch,
                    content: e.target.value,
                  });
                }, 500)}
                prefix={<IoSearchOutline size={15} />}
                allowClear
                className="mr-1"
              />
              <Button
                className="font-bold font-[16px]"
                type="text"
                onClick={onCloseChatMessage}
              >
                {languageMap?.["app.close"] ?? "Close"}
              </Button>
            </div>
          )}
        </div>
        <div
          className="chat-body w-full h-[100%] bg-white border-y overflow-y-auto overflow-y-scroll-email px-[15px]"
          ref={notificationRepliesRef}
        >
          {topMessageList?.map((msg, index) => {
            const isLastItem = index === topMessageList?.length - 1;
            return (
              <div key={msg?.userMailId}>
                {index === 0 ? (
                  <div
                    className={`pt-[15px] ${!msg?.isDraft && "pt-[10px]"}`}
                  />
                ) : (
                  renderMailDivider(msg)
                )}
                <MailReply
                  ref={(el) => {
                    if (el) mailReplyRefs.current[msg.userMailId] = el;
                    else delete mailReplyRefs.current[msg.userMailId];
                  }}
                  notification={msg}
                  isLastItem={isLastItem}
                  isTopMessage={true}
                  setIsSendingSuccess={setIsSendingSuccess}
                  setIsReplyAll={setIsReplyAll}
                  setTotalNotificationItem={setTotalNotificationItem}
                  addMemberOrg={addMemberOrg}
                  listMember={listMember}
                  totalMember={totalMember}
                  ccList={ccList}
                  totalCC={totalCC}
                  setSelectedMessage={setSelectedMessage}
                  setIsModalMembersReadUnread={setIsModalMembersReadUnread}
                  onSentSuccess={scrollToTop}
                  onDirtyChange={(dirty) =>
                    handleDirtyChange(msg.mailId, dirty)
                  }
                />
              </div>
            );
          })}

          {/* open up */}
          {showLoadMoreIcon}

          {bottomMessageList?.map((msg, index) => {
            if (msg?.isDraft === true) return <></>;

            const isLastItem = index === bottomMessageList?.length - 1;

            return (
              <div key={msg?.userMailId}>
                {renderMailDivider(msg)}
                <MailReply
                  ref={(el) => {
                    if (el) mailReplyRefs.current[msg.userMailId] = el;
                    else delete mailReplyRefs.current[msg.userMailId];
                  }}
                  notification={msg}
                  isLastItem={isLastItem}
                  topMessageList={topMessageList}
                  setTopMessageList={setTopMessageList}
                  bottomMessageList={bottomMessageList}
                  setBottomMessageList={setBottomMessageList}
                  isTopMessage={false}
                  listMember={listMember}
                  totalMember={totalMember}
                  ccList={ccList}
                  totalCC={totalCC}
                  setIsSendingSuccess={setIsSendingSuccess}
                  setTotalNotificationItem={setTotalNotificationItem}
                  addMemberOrg={addMemberOrg}
                  setSelectedMessage={setSelectedMessage}
                  setIsModalMembersReadUnread={setIsModalMembersReadUnread}
                  onSentSuccess={scrollToTop}
                  onDirtyChange={(dirty) =>
                    handleDirtyChange(msg.mailId, dirty)
                  }
                />
              </div>
            );
          })}

          <div ref={bottomMessagesRef} />
          <div className="mb-[80px]" />
        </div>
        {isLoading && (
          <div className="relative bottom-[50%] left-[50%]">
            <Spin
              indicator={<LoadingOutlined className="text-[35px]" spin />}
            />
          </div>
        )}
      </div>
      <SideBarMail isOpen={isMenu} onClose={() => setIsMenu(false)} />
      {isOpenModalNotifyChange && (
        <GeneralModal
          title={languageMap?.["modal.draft.title"] ?? "Save draft?"}
          content={
            languageMap?.["modal.draft.content"] ??
            "You have unsaved changes. Do you want to save this as a draft before leaving?"
          }
          open={isOpenModalNotifyChange}
          onConfirm={handleSaveAndLeave}
          onDiscard={handleDiscardAndLeave}
          onCancel={handleCancelLeave}
          confirmText="Save"
          discardText="Discard"
          cancelText="Cancel"
        />
      )}
      {isModalLabelGroup && (
        <LabelModal
          labelSelectedId={labelSelectedId}
          setLabelSelectedId={setLabelSelectedId}
          handleUpdateConversationList={handleUpdateConversationList}
          conversationList={conversationList}
          isModalLabelOpen={isModalLabelGroup}
          setIsModalLabelOpen={setIsModalLabelGroup}
          selectedConversation={selectedConversation}
          setSelectedConversation={setSelectedConversation}
          bottomMessagesRef={bottomMessagesRef}
        />
      )}
      {openModalShowMember && (
        <DirectoryProvider>
          <MemberModal
            selectedConversation={selectedConversation}
            openModalShowMember={openModalShowMember}
            handleCancelModalShowMember={handleCancelModalShowMember}
          />
        </DirectoryProvider>
      )}
      {isModalMembersReadUnread && (
        <MemberReadUnreadModal
          conversationId={selectedConversation?.conversationId}
          conversationType={selectedConversation?.type}
          messageId={selectedMessage?.mailId}
          onCancel={() => setIsModalMembersReadUnread(false)}
          isOpen={isModalMembersReadUnread}
        />
      )}

      {isOpenModalDeleteConversation && (
        <GeneralModal
          title={
            languageMap?.["modal.confirm.titleDeleteMessage"] ??
            "Are you sure you want to delete the message notifications?"
          }
          content={
            languageMap?.["modal.confirm.contentDeleteMessage"] ??
            "Once deleted, the messages will be gone permanently."
          }
          open={isOpenModalDeleteConversation}
          onConfirm={onDeleteMessageNotifications}
          onCancel={() => setIsOpenModalDeleteConversation(false)}
        />
      )}
      {isForwardAllMail && (
        <ForwardAllMailModal
          isForwardAllMail={isForwardAllMail}
          setIsForwardAllMail={setIsForwardAllMail}
          addMemberOrg={addMemberOrg}
        />
      )}
    </div>
  );
};

export { MailDetail };
